import React from "react"
import { NoteView } from "../../../../component"
import { useTranslation } from "react-i18next"

const AreaRegisteredNoteView = ({ tab }) => {
  const { t } = useTranslation()

  let label

  switch (tab) {
    case "not-planted-yet":
      label = "label_not_planted_yet_note"
      break
    case "active-planting":
      label = "label_active_planting_note"
      break
    case "upcoming-harvest":
      label = "label_upcoming_harvest_note"
      break
    case "harvest-period":
      label = "label_harvest_period_note"
      break
    case "harvested":
      label = "label_harvested_note"
      break
    case "anomaly":
      label = "label_anomaly_note"
      break
    default:
      label = "label_not_planted_yet_note"
      break
  }

  return (
    <NoteView
      variant={"success"}
      title={
        <>
          <div className="pl-6">{t(label)}</div>
        </>
      }
    />
  )
}

export default AreaRegisteredNoteView
